module.exports = __webpack_public_path__ + "img/manda_029.0251f94b.png";